import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { DialogBase, Props, State } from "./DialogBase";

export class DialogForReportDataTableComponent extends DialogBase<Props, State> {

    constructor(props: Props) {
        super(props);
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog
                    header={this.props.isEng ? "ReportDataTable Properties" : "Propriétés du tableau de données"}
                    footer={this.renderFooter(this.props)}
                    visible={this.props.dialogVisible}
                    style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {this.renderOptions()}
                </Dialog>
            </>
        );
        return html;
    }

    renderOptions = () => {
        const ele = this.props.ele as any;

        // Initialize defaults
        if (ele.AllowUpload === undefined) ele.AllowUpload = false;
        if (ele.ValidateXML === undefined) ele.ValidateXML = true;
        if (ele.MaxFileSize === undefined) ele.MaxFileSize = 20;
        if (ele.AcceptFileType === undefined) ele.AcceptFileType = '.xml';
        if (ele.ApiMethod === undefined) ele.ApiMethod = 'PUT';

        const apiMethods = [
            { label: 'PUT', value: 'PUT' },
            { label: 'POST', value: 'POST' }
        ];

        const authOptions = [
            { label: 'None', value: '' },
            { label: 'PS (Public Secure)', value: 'ps' },
            { label: 'BPS (Business Portal)', value: 'bps' }
        ];

        return (
            <div>
                {/* Allow Upload Section */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`allow-upload-${ele.Id}`}>Allow File Upload</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            inputId={`allow-upload-${ele.Id}`}
                            checked={ele.AllowUpload === true}
                            onChange={(e) => {
                                ele.AllowUpload = e.checked;
                                this.props.callback();
                            }}
                        />
                        <label htmlFor={`allow-upload-${ele.Id}`} style={{ marginLeft: '8px' }}>
                            Enable file upload section with Validate/Continue button
                        </label>
                    </div>
                </div>

                {/* API URL */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`api-url-${ele.Id}`}>API URL</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            id={`api-url-${ele.Id}`}
                            className="ontario-input"
                            style={{ width: '100%' }}
                            value={ele.ApiUrl || ''}
                            placeholder="e.g., ${env.API_BASE}/validation/validate"
                            onChange={(e) => {
                                ele.ApiUrl = e.target.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                {/* API Method */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`api-method-${ele.Id}`}>API Method</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown
                            id={`api-method-${ele.Id}`}
                            value={ele.ApiMethod || 'PUT'}
                            options={apiMethods}
                            onChange={(e) => {
                                ele.ApiMethod = e.value;
                                this.props.callback();
                            }}
                            style={{ width: '150px' }}
                        />
                    </div>
                </div>

                {/* Auth Required */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`auth-required-${ele.Id}`}>Authentication</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown
                            id={`auth-required-${ele.Id}`}
                            value={ele.AuthRequired || ''}
                            options={authOptions}
                            onChange={(e) => {
                                ele.AuthRequired = e.value;
                                this.props.callback();
                            }}
                            style={{ width: '200px' }}
                        />
                    </div>
                </div>

                {/* Accept File Type */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`accept-type-${ele.Id}`}>Accepted File Types</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            id={`accept-type-${ele.Id}`}
                            className="ontario-input"
                            value={ele.AcceptFileType || '.xml'}
                            placeholder=".xml"
                            onChange={(e) => {
                                ele.AcceptFileType = e.target.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                {/* Max File Size */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`max-size-${ele.Id}`}>Max File Size (MB)</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            id={`max-size-${ele.Id}`}
                            className="ontario-input"
                            type="number"
                            value={ele.MaxFileSize || 20}
                            onChange={(e) => {
                                ele.MaxFileSize = parseInt(e.target.value) || 20;
                                this.props.callback();
                            }}
                            style={{ width: '100px' }}
                        />
                    </div>
                </div>

                {/* Validate XML */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`validate-xml-${ele.Id}`}>Validate XML</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            inputId={`validate-xml-${ele.Id}`}
                            checked={ele.ValidateXML !== false}
                            onChange={(e) => {
                                ele.ValidateXML = e.checked;
                                this.props.callback();
                            }}
                        />
                        <label htmlFor={`validate-xml-${ele.Id}`} style={{ marginLeft: '8px' }}>
                            Validate XML structure before upload
                        </label>
                    </div>
                </div>

                {/* Read Only */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={`read-only-${ele.Id}`}>Read Only</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox
                            inputId={`read-only-${ele.Id}`}
                            checked={ele.ReadOnly === true}
                            onChange={(e) => {
                                ele.ReadOnly = e.checked;
                                this.props.callback();
                            }}
                        />
                        <label htmlFor={`read-only-${ele.Id}`} style={{ marginLeft: '8px' }}>
                            Display as read-only table (for final review)
                        </label>
                    </div>
                </div>

                {/* Configurable Text Section */}
                {ele.AllowUpload && (
                    <>
                        <div style={{ marginTop: '20px', borderTop: '1px solid #ddd', paddingTop: '15px' }}>
                            <strong>Upload Section Content (Optional)</strong>
                            <p style={{ margin: '5px 0 0 0', fontSize: '0.9em', color: '#666' }}>
                                Use the rich text editor to customize the upload section content. Leave empty to use defaults.
                            </p>
                        </div>

                        {/* Upload Section Content - English */}
                        <div style={{ marginTop: '15px' }}>
                            <label htmlFor={`upload-content-en-${ele.Id}`} style={{ fontWeight: 'bold' }}>
                                Upload Section Content (EN)
                            </label>
                            <Editor
                                id={`upload-content-en-${ele.Id}`}
                                className="ontario-input"
                                style={{ height: 'auto', marginTop: '5px' }}
                                value={ele.UploadSectionContentEN || ''}
                                onTextChange={(e) => {
                                    ele.UploadSectionContentEN = e.htmlValue;
                                    this.props.callback();
                                }}
                            />
                        </div>

                        {/* Upload Section Content - French */}
                        <div style={{ marginTop: '15px' }}>
                            <label htmlFor={`upload-content-fr-${ele.Id}`} style={{ fontWeight: 'bold' }}>
                                Upload Section Content (FR)
                            </label>
                            <Editor
                                id={`upload-content-fr-${ele.Id}`}
                                className="ontario-input"
                                style={{ height: 'auto', marginTop: '5px' }}
                                value={ele.UploadSectionContentFR || ''}
                                onTextChange={(e) => {
                                    ele.UploadSectionContentFR = e.htmlValue;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </>
                )}

                {/* Help text */}
                <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                    <strong>Usage:</strong>
                    <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
                        <li><strong>Section 2 (Validation):</strong> Enable "Allow File Upload" and configure API URL</li>
                        <li><strong>Section 3 (Review):</strong> Enable "Read Only" only</li>
                    </ul>
                    <p style={{ margin: 0, fontSize: '0.9em', color: '#666' }}>
                        When "Allow File Upload" is enabled, the component includes a file upload section and
                        Validate/Continue button. No separate button component needed!
                    </p>
                </div>
            </div>
        );
    }

    render() {
        let basicHtmlString = [];
        basicHtmlString.push(this.generateHtmlString());
        return basicHtmlString;
    }
}